import React, { useEffect } from "react";

import html from "../assets/HTML5.png";
import css from "../assets/css.png";
import javascript from "../assets/js.png";
import reactImage from "../assets/react.png";
import nextjs from "../assets/next.png";
import git from "../assets/git.png";
import tailwind from "../assets/tailwind.png";
import AOS from 'aos';
import "aos/dist/aos.css";

const Skills = () => {
  const skills = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: reactImage,
      title: "React",
      style: "shadow-blue-600",
    },
    {
      id: 5,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 6,
      src: nextjs,
      title: "Next JS",
      style: "shadow-white",
    },
    {
      id: 7,
      src: git,
      title: "Git",
      style: "shadow-orange-600",
    },
  ];

  useEffect(() => {
    AOS.init({ duration: 1000 });
    AOS.refresh();
  }, []);

  return (
    <div
      name="skills"
      className="bg-gradient-to-t from-[#004643] to-gray-900 w-full h-auto lg:p-6"
    >
      <div className="max-w-screen-lg mx-auto p-9 flex flex-col justify-center w-full h-auto text-[#fffffe]">
        <div data-aos="fade-down" data-aos-delay="200" data-aos-once="true">
          <p className="text-4xl font-logo border-b-4 border-gray-500 p-2 inline" >
            Skills 🤹🏻
          </p>
          <p className="py-6 text-[#abd1c6]">These are the technologies I've worked with, and I am familiar with their use</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-8 text-center py-8 px-12 sm:px-0" data-aos="flip-up" data-aos-delay="200" data-aos-once="true" >
          {skills.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-md ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
